(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["404"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-404-root]');
    if (!root) return;

    var termino = (root.getAttribute('data-404-term') || '').trim();
    var predictiveUrl = root.getAttribute('data-404-predictive-url');
    var caja = root.querySelector('[data-404-suggestions]');
    var grilla = root.querySelector('[data-404-cards]');
    if (!termino || !predictiveUrl || !caja || !grilla) return;

    var destino = new URL(predictiveUrl, window.location.origin);
    destino.searchParams.set('q', termino);
    destino.searchParams.set('resources[type]', 'product');
    destino.searchParams.set('resources[limit]', '4');
    destino.searchParams.set('resources[options][unavailable_products]', 'hide');

    // Red de seguridad de la regalería: los productos con tag `regalo` (precio
    // $0) no se sugieren nunca. Igual que en el header, el filtro real es del
    // Connect; esto es sólo el respaldo del tema.
    function esRegalo(producto) {
      return (
        Array.isArray(producto.tags) &&
        producto.tags.some(function (tag) {
          return String(tag).toLowerCase() === 'regalo';
        })
      );
    }

    function tarjeta(producto) {
      var enlace = document.createElement('a');
      enlace.className = 'error-404__card';
      enlace.href = producto.url;

      var imagen = producto.featured_image && producto.featured_image.url;
      if (imagen) {
        var img = document.createElement('img');
        img.className = 'error-404__card-image';
        img.src = imagen + (imagen.indexOf('?') === -1 ? '?' : '&') + 'width=400';
        img.alt = '';
        img.loading = 'lazy';
        enlace.appendChild(img);
      }

      if (producto.vendor) {
        var marca = document.createElement('span');
        marca.className = 'error-404__card-vendor';
        marca.textContent = producto.vendor;
        enlace.appendChild(marca);
      }

      var titulo = document.createElement('span');
      titulo.className = 'error-404__card-title';
      titulo.textContent = producto.title;
      enlace.appendChild(titulo);

      return enlace;
    }

    fetch(destino, { headers: { Accept: 'application/json' } })
      .then(function (respuesta) {
        if (!respuesta.ok) throw new Error('predictive-search');
        return respuesta.json();
      })
      .then(function (datos) {
        var resources = datos.resources || {};
        var results = resources.results || {};
        var productos = (results.products || []).filter(function (producto) {
          return !esRegalo(producto);
        });
        if (!productos.length) return;

        productos.slice(0, 4).forEach(function (producto) {
          grilla.appendChild(tarjeta(producto));
        });
        caja.hidden = false;
      })
      .catch(function () {
        // Silencio a propósito: la página ya sirve sin las sugerencias.
      });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brands-carousel"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // --- Indice de marcas: filtro por inicial (#, A-Z) y por texto. ---
    // Sin acentos y en mayusculas, para que «Gres» encuentre «Grès» y «nuggela»
    // encuentre «Nuggela & Sulé».
    function bcFold(value) {
      var text = value || '';
      if (text.normalize) text = text.normalize('NFD').replace(/[̀-ͯ]/g, '');
      return text.toUpperCase();
    }

    document.querySelectorAll('.brands-carousel--grid').forEach(function(section) {
      var bar = section.querySelector('[data-brands-filter]');
      if (!bar) return;

      var items = Array.prototype.slice.call(section.querySelectorAll('.brands-carousel__item'));
      if (items.length === 0) return;

      var available = {};
      items.forEach(function(item) {
        var name = bcFold(item.getAttribute('data-brand-name'));
        // Las marcas que arrancan con numero («4711 OEDC») caen en `#`, igual
        // que en el indice viejo.
        var initial = /^[0-9]/.test(name) ? '#' : name.charAt(0);
        item.setAttribute('data-brand-key', name);
        item.setAttribute('data-brand-initial', initial);
        if (initial) available[initial] = true;
      });

      var buttons = Array.prototype.slice.call(bar.querySelectorAll('[data-brands-letter]'));
      buttons.forEach(function(button) {
        var letter = button.getAttribute('data-brands-letter');
        if (letter && !available[letter]) button.disabled = true;
      });

      var input = bar.querySelector('[data-brands-search]');
      var countEl = bar.querySelector('[data-brands-count]');
      var emptyEl = section.querySelector('[data-brands-empty]');
      var activeLetter = '';

      function apply() {
        var query = bcFold(input ? input.value.trim() : '');
        var shown = 0;

        items.forEach(function(item) {
          var matchLetter = !activeLetter || item.getAttribute('data-brand-initial') === activeLetter;
          var matchQuery = !query || item.getAttribute('data-brand-key').indexOf(query) !== -1;
          var visible = matchLetter && matchQuery;
          item.hidden = !visible;
          if (visible) shown++;
        });

        if (countEl) {
          var one = countEl.getAttribute('data-count-one');
          var other = countEl.getAttribute('data-count-other') || '';
          countEl.textContent = shown === 1 ? one : other.replace('%n%', shown);
        }
        if (emptyEl) emptyEl.hidden = shown !== 0;
      }

      buttons.forEach(function(button) {
        button.addEventListener('click', function() {
          var letter = button.getAttribute('data-brands-letter');
          // Volver a tocar la letra activa la suelta, como en el sitio viejo.
          activeLetter = activeLetter === letter ? '' : letter;
          buttons.forEach(function(other) {
            var isActive = other.getAttribute('data-brands-letter') === activeLetter;
            other.classList.toggle('is-active', isActive);
          });
          apply();
        });
      });

      if (input) {
        input.addEventListener('input', apply);
        // El teclado de iOS pone un botón «buscar» que envía: no hay form, pero
        // Enter igual no tiene que recargar nada.
        input.addEventListener('keydown', function(event) {
          if (event.key === 'Enter') event.preventDefault();
        });
      }

      bar.hidden = false;
      apply();
    });

    document.querySelectorAll('.brands-carousel').forEach(function(section) {
      // En modo grilla no hay nada que desplazar: no hay flechas ni puntos y la
      // grilla la resuelve el CSS. Salir antes evita dejarle un transform al
      // track que despues haya que neutralizar.
      if (section.classList.contains('brands-carousel--grid')) return;
      var track = section.querySelector('.brands-carousel__track');
      var items = track.querySelectorAll('.brands-carousel__item');
      if (items.length === 0) return;

      var prev = section.querySelector('.brands-carousel__arrow--prev');
      var next = section.querySelector('.brands-carousel__arrow--next');
      var dotsContainer = section.querySelector('.brands-carousel__dots');
      var current = 0;

      function perPage() { return window.innerWidth < 768 ? 2 : 4; }
      function pages() { return Math.ceil(items.length / perPage()); }

      function goTo(page) {
        var p = pages();
        current = (page + p) % p;
        var offset = current * perPage() * (100 / perPage());
        track.style.transform = 'translateX(-' + offset + '%)';
        if (dotsContainer) {
          dotsContainer.querySelectorAll('.brands-carousel__dot').forEach(function(d, i) {
            d.classList.toggle('is-active', i === current);
          });
        }
      }

      if (dotsContainer) {
        for (var i = 0; i < pages(); i++) {
          var dot = document.createElement('button');
          dot.className = 'brands-carousel__dot' + (i === 0 ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Page ' + (i + 1));
          (function(idx) { dot.addEventListener('click', function() { goTo(idx); }); })(i);
          dotsContainer.appendChild(dot);
        }
      }

      if (prev) prev.addEventListener('click', function() { goTo(current - 1); });
      if (next) next.addEventListener('click', function() { goTo(current + 1); });

      goTo(0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initFeaturedCarousel(root) {
      if (root.dataset.fpReady === '1') return;
      var viewport = root.querySelector('[data-fp-viewport]');
      if (!viewport) return;
      root.dataset.fpReady = '1';

      var prev = root.querySelector('.featured-products__arrow--prev');
      var next = root.querySelector('.featured-products__arrow--next');
      var dots = root.querySelector('[data-fp-dots]');
      var dotLabel = dots ? (dots.getAttribute('data-dot-label') || 'NUM') : 'NUM';

      function maxScroll() { return viewport.scrollWidth - viewport.clientWidth; }
      function hasOverflow() { return maxScroll() > 1; }
      function pageCount() {
        if (!hasOverflow() || viewport.clientWidth === 0) return 1;
        return Math.ceil(viewport.scrollWidth / viewport.clientWidth);
      }
      function currentPage() {
        var max = maxScroll();
        if (max <= 0) return 0;
        return Math.round((viewport.scrollLeft / max) * (pageCount() - 1));
      }
      function scrollToPage(idx) {
        var pages = pageCount();
        var target;
        if (idx <= 0) target = 0;
        else if (idx >= pages - 1) target = maxScroll();
        else target = idx * viewport.clientWidth;
        viewport.scrollTo({ left: target, behavior: 'smooth' });
      }

      function renderDots() {
        if (!dots) return;
        dots.innerHTML = '';
        var pages = pageCount();
        if (pages < 2) return;
        for (var i = 0; i < pages; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'featured-products__dot';
          dot.setAttribute('aria-label', dotLabel.replace('NUM', String(i + 1)));
          (function(idx) {
            dot.addEventListener('click', function() { scrollToPage(idx); });
          })(i);
          dots.appendChild(dot);
        }
      }

      function update() {
        var overflow = hasOverflow();
        // tolerancia: el padding izquierdo del viewport corre el punto de
        // reposo del snap unos pixeles, asi que 0 "real" nunca se alcanza.
        var EDGE = 10;
        if (prev) {
          prev.hidden = !overflow;
          prev.disabled = viewport.scrollLeft <= EDGE;
        }
        if (next) {
          next.hidden = !overflow;
          next.disabled = viewport.scrollLeft >= maxScroll() - EDGE;
        }
        if (dots) {
          var active = currentPage();
          dots.querySelectorAll('.featured-products__dot').forEach(function(d, i) {
            d.classList.toggle('is-active', i === active);
          });
        }
      }

      if (prev) {
        prev.addEventListener('click', function() {
          viewport.scrollBy({ left: -viewport.clientWidth, behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function() {
          viewport.scrollBy({ left: viewport.clientWidth, behavior: 'smooth' });
        });
      }

      var ticking = false;
      viewport.addEventListener('scroll', function() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function() {
          ticking = false;
          update();
        });
      });
      window.addEventListener('resize', function() {
        renderDots();
        update();
      });

      renderDots();
      update();
    }

    // Los chips de familia NO se inicializan aca: su intercambio vive en
    // `snippets/familia-tamanos.liquid`, con un unico listener delegado en
    // `document`, porque la misma tarjeta la dibujan tambien la coleccion y el
    // buscador y tres copias del mismo codigo se iban a separar solas.
    document.querySelectorAll('[data-fp-root]').forEach(initFeaturedCarousel);
    document.addEventListener('shopify:section:load', function(event) {
      event.target.querySelectorAll('[data-fp-root]').forEach(initFeaturedCarousel);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-scalpers"]) return;
  try {
    
  console.log('Hero Scalpers loaded');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.hero-slideshow').forEach(function(el) {
      var track = el.querySelector('.hero-slideshow__track');
      var slides = el.querySelectorAll('.hero-slideshow__slide');
      if (slides.length <= 1) return;

      var dots = el.querySelectorAll('.hero-slideshow__dot');
      var autoplay = el.dataset.autoplay === 'true';
      var speed = (parseInt(el.dataset.speed, 10) || 5) * 1000;
      var current = 0;
      var timer;

      function goTo(i) {
        current = (i + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + (current * 100) + '%)';
        dots.forEach(function(d, idx) { d.classList.toggle('is-active', idx === current); });
      }

      el.querySelectorAll('.hero-slideshow__arrow--prev').forEach(function(btn) {
        btn.addEventListener('click', function() { clearInterval(timer); goTo(current - 1); });
      });
      el.querySelectorAll('.hero-slideshow__arrow--next').forEach(function(btn) {
        btn.addEventListener('click', function() { clearInterval(timer); goTo(current + 1); });
      });
      dots.forEach(function(dot, i) {
        dot.addEventListener('click', function() { clearInterval(timer); goTo(i); });
      });

      if (autoplay) { timer = setInterval(function() { goTo(current + 1); }, speed); }
      goTo(0);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
